export default "__VITE_ASSET__TB5YP_Lg__"